import { Paragraph, Headline } from 'Common';
import { TEXT } from 'locales/translations';
import { ThemeContainer } from 'Container';
import { themeFeeling } from 'Theme';
import { HealthInsuranceSliderSectionStyle } from './HealthInsuranceSliderSection.style';
import { HealthCooperationSlider } from 'Component';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';

export const HealthInsuranceSliderSection = () => {
  return (
    <ThemeContainer theme={themeFeeling}>
      <HealthInsuranceSliderSectionStyle
        id="health-section"
        backgroundColor="pink"
        className="text-center"
        type="full-width"
        aria-labelledby="health-slider-heading"
        role="region"
      >
        <hr className="white-hr" aria-hidden="true" />
        <HealthCooperationSlider
          dotsColor="dark-pink"
          id="cooperations-slider"
          headline={
            <Headline id="health-slider-heading" level={4}>
              {TEXT.healthPageSection.sliderHeadline}
            </Headline>
          }
        >
          <Paragraph className="text-center slider-body" dangerouslySetInnerHTML={{ __html: TEXT.healthPageSection.sliderBody }} />
        </HealthCooperationSlider>
      </HealthInsuranceSliderSectionStyle>
    </ThemeContainer>
  );
};
